exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_outsideWrap_3ANDc {\n  width: 100%;\n}\n\n.index_outsideWrap_3ANDc .index_insideWrap_1_1bnhj {\n  width: 100%;\n  padding: 0 0.75rem 0.75rem 0.75rem;\n}\n\n.index_outsideWrap_3ANDc .index_insideWrap_2_3TfDU {\n  width: 100%;\n  padding: 0 0.75rem 0.75rem 0.75rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);

// Exports
exports.locals = {
	"outsideWrap": "index_outsideWrap_3ANDc",
	"insideWrap_1": "index_insideWrap_1_1bnhj",
	"insideWrap_2": "index_insideWrap_2_3TfDU"
};